<a [href]="href()" class="link" target="_blank">
    @if (variant() === 'card') {
        <span class="title">
            @if (draft()) {
                <span class="draft">Draft:</span>
            }
            {{ title() }}
        </span>
        <span [title]="branchLine()" class="branch">{{ branchLine() }}</span>
        <span class="status-line">
            <app-status-badge [tone]="statusTone()" size="sm" variant="tag">{{ status() }}</app-status-badge>
            <span class="when">{{ when() }}</span>
            <ng-container [ngTemplateOutlet]="reviewersTpl"></ng-container>
        </span>
        @for (item of workItems(); track item.id) {
            <span [title]="item.title" class="work-item">
                <span class="type">{{ item.type }}</span>
                <app-status-badge [class.dark]="item.stateTone === 'dark'"
                                  [tone]="item.stateTone === 'dark' ? 'neutral' : $any(item.stateTone)"
                                  size="sm" variant="tag">{{ item.state }}</app-status-badge>
                <span class="wi-title"><span class="nr">#{{ item.id }}</span> {{ item.title }}</span>
            </span>
        }
    } @else {
        <span class="main">
            <span [title]="title()" class="title">
                @if (draft()) {
                    <span class="draft">Draft:</span>
                }
                {{ title() }}
            </span>
            <span class="meta">
                @if (merge(); as merge) {
                    <i [class]="'fa-regular fa-code-merge ui-' + merge.tone" [title]="merge.label"></i>
                }
                <span class="nr">!{{ number() }}</span> · {{ when() }}
            </span>
        </span>
        <ng-container [ngTemplateOutlet]="reviewersTpl"></ng-container>
    }
</a>

<ng-template #reviewersTpl>
    <span class="reviewers">
        @for (reviewer of reviewers(); track $index) {
            <app-avatar [name]="reviewer.name" [seed]="reviewer.seed ?? reviewer.name" [size]="variant() === 'card' ? 'sm' : 'md'"
                        [vote]="reviewer.vote"></app-avatar>
        } @empty {
            <span class="none">Geen reviewers</span>
        }
    </span>
</ng-template>
